import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'PlinkoCardLayout',
  width: 126,
  height: 176,
  x: 0,
  y: 0,
  list: [
    {
      id: 'b99ca80f-f264-4409-b075-daa92acaf166',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'd814d08e-e621-4ff9-80a6-421bde79e887',
      type: 'Graphics',
      name: 'ftuxOverlay',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'Rectangle',
        x: 0,
        y: 0,
        width: 100,
        height: 200
      },
      parent: 'b99ca80f-f264-4409-b075-daa92acaf166',
      bake: false,
      commands: [
        {
          id: 'edfd247f-59b0-41c9-aace-57d3122aedcb',
          type: 'beginFill',
          color: 0,
          alpha: 0.4
        },
        {
          id: 'e3b3ef72-7594-436c-9fc1-9f1eb6bf8a12',
          type: 'drawRect',
          x: -1500,
          y: -1000,
          width: 3000,
          height: 2000
        }
      ],
      data: ''
    },
    {
      id: 'be1bfa51-470a-4dc3-9344-26cc1b14a6f5',
      type: 'Armature',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -20,
      scale: {
        x: 0.81,
        y: 0.81
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b99ca80f-f264-4409-b075-daa92acaf166',
      data: '',
      animationName: 'revealed',
      armatureName: 'card',
      dragonbonesName: 'treasure_card',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    },
    {
      id: 'c4427090-bc3b-49c2-9e3f-37d9c09ea662',
      type: 'Armature',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b99ca80f-f264-4409-b075-daa92acaf166',
      data: '',
      animationName: 'animation',
      armatureName: 'card_revealed_effect',
      dragonbonesName: 'treasure_card',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    },
    {
      id: '8351d773-9bb3-4d8b-8580-f91c90cecc21',
      type: 'Armature',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 80,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b99ca80f-f264-4409-b075-daa92acaf166',
      data: '',
      animationName: 'animation',
      armatureName: 'check',
      dragonbonesName: 'treasure_card',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    },
    {
      id: '7402fefe-ee3b-41de-8cce-f47af4f03044',
      type: 'NineSlicePlane',
      name: 'ftuxText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 176,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 150,
        y: 50
      },
      width: 300,
      height: 100,
      leftWidth: 0,
      topHeight: 0,
      rightWidth: 0,
      bottomHeight: 0,
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -1000,
        y: -500,
        width: 2000,
        height: 1000
      },
      texture: 'plinko_ftux_bg',
      parent: 'b99ca80f-f264-4409-b075-daa92acaf166',
      data: ''
    },
    {
      id: 'b889bed8-a711-4da9-a084-31f6663b60a7',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 150,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PlinkoCardFTUX',
      localize: true,
      maxWidth: 260,
      maxHeight: 87,
      maxFontSize: 20,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ba372b',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 306,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '7402fefe-ee3b-41de-8cce-f47af4f03044',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class PlinkoCardLayout {
  static raw = raw;
  root: PIXI.Container
  ftuxOverlay: PIXI.Graphics
  ftuxText: PIXI.NineSlicePlane

  constructor() {
    populate(this, raw);
  }
}
